const CA_POSTAL_LETTER = "ABCEGHJ-NPRSTVXY";
const CA_POSTAL_OTHER_LETTER = "ABCEGHJ-NPRSTVWXYZ";
const CA_POSTAL_PATTERN = new RegExp(
  `^[${CA_POSTAL_LETTER}]\\d[${CA_POSTAL_OTHER_LETTER}] \\d[${CA_POSTAL_OTHER_LETTER}]\\d$`,
);
const CA_POSTAL_INPUT_PATTERN = new RegExp(
  `^[${CA_POSTAL_LETTER}]\\d[${CA_POSTAL_OTHER_LETTER}]\\s?\\d[${CA_POSTAL_OTHER_LETTER}]\\d$`,
  "i",
);

export const POSTAL_CODE_FORMAT = {
  canonical: "12345",
  pattern: /^\d{5}$/,
  extendedPattern: /^\d{5}-\d{4}$/,
  caPattern: CA_POSTAL_PATTERN,

  validate(value: string): boolean {
    return this.normalize(value) !== undefined;
  },

  normalize(value: string | undefined | null): string | undefined {
    if (!value) return undefined;
    const trimmed = value.trim();

    if (CA_POSTAL_INPUT_PATTERN.test(trimmed)) {
      const upper = trimmed.toUpperCase().replace(/\s+/g, "");
      return `${upper.slice(0, 3)} ${upper.slice(3)}`;
    }

    const digits = trimmed.replace(/\D/g, "");

    if (digits.length === 5) return digits;
    if (digits.length === 9) return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    if (digits.length > 5 && digits.length < 9) return digits.slice(0, 5);

    return undefined;
  },

  format(value: string): string {
    const trimmed = value.trim();
    if (CA_POSTAL_INPUT_PATTERN.test(trimmed)) {
      const upper = trimmed.toUpperCase().replace(/\s+/g, "");
      return `${upper.slice(0, 3)} ${upper.slice(3)}`;
    }
    const digits = trimmed.replace(/\D/g, "").slice(0, 9);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  },

  toFiveDigit(value: string | undefined | null): string | undefined {
    const normalized = this.normalize(value);
    if (!normalized) return undefined;
    if (
      this.pattern.test(normalized) ||
      this.extendedPattern.test(normalized)
    ) {
      return normalized.slice(0, 5);
    }
    return undefined;
  },

  toComparable(value: string | undefined | null): string | undefined {
    const normalized = this.normalize(value);
    if (!normalized) return undefined;
    if (this.caPattern.test(normalized)) return normalized.replace(/\s/g, "");
    return this.toFiveDigit(normalized);
  },

  errorMessage: "Enter a US ZIP (12345) or Canadian postal (A1A 1A1)",
} as const;
